import React, { useEffect } from 'react';

import ActionButton from '~components/atoms/ActionButton';

const DownloadCSV = (
    {
        header,
        data,
        fileName,
        buttonLabel = 'Download CSV',
        isLoading,
        onClick,
        cleanup,
    }: {
        header: Array<string>;
        data: Array<number | string | object>;
        fileName: string;
        buttonLabel?: string;
        isLoading?: boolean;
        onClick: () => void;
        cleanup?: () => void;
    },
) => {
    useEffect(() => {
        if (data.length > 0) downloadCSV();
    }, [data]);

    type CSVRow = Record<string, string | number | boolean | null | undefined>;

    const convertToCSV = <T extends CSVRow>(objArray: T[]): string => {
        if (objArray.length === 0) return '';

        const headersText = Object.keys(objArray[0]);
        let csv = header.join(',') + '\r\n';

        for (const row of objArray) {
            const line = headersText.map((key) => {
                const raw = row[key];

                // for admin export permission
                if (key === 'permission'){
                    return raw;
                }

                // Convert values safely to string
                let value: string =
                raw === null || raw === undefined
                    ? ''
                    : typeof raw === 'string'
                        ? raw
                        : String(raw);

                // Escape double quotes
                value = value.replace(/"/g, '""');

                // If value contains comma, new line, or quote → wrap in quotes
                if (/[",\n]/.test(value)) {
                    value = `"${value}"`;
                }

                return value;
            });

            csv += line.join(',') + '\r\n';
        }

        return csv;
    };

    const downloadCSV = () => {
        const csvData = new Blob([convertToCSV(data as CSVRow[])], { type: 'text/csv' });
        const csvURL = URL.createObjectURL(csvData);
        const link = document.createElement('a');

        link.href = csvURL;
        link.download = `${fileName}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        if (cleanup) cleanup();
    };

    return (
        <ActionButton
            label={buttonLabel}
            onClick={onClick}
            isLoading={isLoading}
        />
    );
};

export default DownloadCSV;
